/**
 * EGroupware eTemplate2 - JS Template base class
 *
 * @license http://opensource.org/licenses/gpl-license.php GPL - GNU General Public License
 * @package etemplate
 * @subpackage api
 * @link https://www.egroupware.org
 * @author Andreas Stöckel
 */


import {Et2Template} from "./Et2Template/Et2Template";

/**
 * @deprecated use Et2Template
 */
export class et2_template extends Et2Template
{
}